/**
 * @class
 * @override
 */
import Base from 'netxcore@netx/core-app/views/appProgressView';

import {MDCLinearProgress} from '@material/linear-progress';

class AppProgressView extends Base {
	/** @override */
	constructor(opts = {}) {
		super(opts);

		// To avoid messing with core atm
		if (this.simulate) {
			this._simulate = this.simulate;
			delete this.simulate;
		}
	}

	/** @override */
	postRender() {
		super.postRender();

		this.progress = new MDCLinearProgress(
			this.el.querySelector('.mdc-linear-progress'),
		);
	}

	/** @override */
	preRender() {
		if (this.progress) {
			this.progress.destroy();
			delete this.progress;
		}

		super.preRender();

		Object.assign(this.templateVars, {
			indeterminate: this._simulate === true,
		});
	}

	/** @override */
	progressUpdated(percentComplete) {
		if (!this.progress) return;

		this.progress.foundation_.setProgress(percentComplete);
	}

	/** @override */
	remove() {
		this.progress && this.progress.destroy();
		super.remove();
	}
}

export default AppProgressView;
